// Map API endpoints here

export default $axios => ({
  add(partnerUserId, dealId, venueId) {
    return $axios.post(
      `/api/partnerUser/${partnerUserId}/favorites/${dealId}/${venueId}`
    );
  },
  remove(partnerUserId, dealId, venueId) {
    return $axios.delete(
      `/api/partnerUser/${partnerUserId}/favorites/${dealId}/${venueId}`
    );
  }
});
